export default __webpack_public_path__ + "static/media/bm-logo_outer.82c4e4ea.svg";